/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import classname from '@search/classname/src';
import { useKeyPress } from '@search/hooks/src/useKeyPress';
import { useYMapApi, ymaps } from '../ApiProvider';
import { IPanorama } from '../ApiProvider/yandex-maps';

import './styles.css';

const cn = classname.bind(null, 'Panorama');

export interface IYMapPanoramaOptions {
    autoFitToViewport?: 'always' | 'ifNull' | 'none';
    controls?: string[];
    direction?: [number, number] | 'auto';
    hotkeysEnabled?: boolean;
    scrollZoomBehavior?: boolean;
    span?: [number, number] | 'auto';
    suppressMapOpenBlock?: boolean;
}

export interface IYMapPanoramaProps {
    point: {
        latitude: number;
        longitude: number;
    };
    onClose: () => void;
    closeButtonEnabled?: boolean;
    isMobile?: boolean;
    options?: IYMapPanoramaOptions;
}

export const YMapPanorama: React.FC<IYMapPanoramaProps> = ({
    point,
    onClose,
    closeButtonEnabled,
    isMobile,
    options = {}
}) => {
    const [ error, setError ] = useState('');
    const ymapsApi: typeof ymaps | undefined = useYMapApi().api();

    const esc = useKeyPress('Escape');

    useEffect(() => {
        esc && onClose();
    }, [ esc, onClose ]);

    useEffect(() => {
        if (ymapsApi?.panorama.isSupported()) {
            ymapsApi.panorama.locate([ point.latitude, point.longitude ]).done(
                (panoramas: [IPanorama]) => {
                    if (panoramas.length > 0) {
                        const player = new ymapsApi.panorama.Player(
                            'panorama',
                            panoramas[0],
                            {
                                autoFitToViewport: isMobile ? 'always' : 'ifNull',
                                controls: isMobile ?
                                    [ 'zoomControl' ] :
                                    [ 'closeControl', 'zoomControl', 'panoramaName' ],
                                ...options
                            }
                        );

                        player.events.add('destroy', onClose);
                    } else {
                        setError('Для данного объявления посмотреть панораму невозможно');
                    }
                },
                () => {
                    setError('');
                }
            );
        }
    }, [ ymapsApi, onClose, point, isMobile, options ]);

    if (error || ! ymapsApi) {
        return (
            <div className={cn()}>
                <div className={cn('error')}>
                    {error ?? 'Невозможно загрузить Яндекс карты - попробуйте обновить страницу.'}
                </div>

                {closeButtonEnabled && (
                    <svg className={cn('icon')} onClick={onClose} height='18' width='18' fill='none'>
                        <path
                            stroke='#1B2233'
                            strokeOpacity='0.92'
                            strokeWidth='1.5'
                            d='M1 1.00001L17 17M17 1L1 17'
                        />
                    </svg>
                )}
            </div>
        );
    }

    return (
        <div id='panorama' className={cn()} />
    );
};
